


































































import { Component, Vue, Watch } from 'vue-property-decorator';
import UpdateAgencyAuthenticationRequest from '@/models/Agencies/UpdateAgencyAuthenticationRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { AgencyModule } from '@/store/modules/agency';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import IntegrationDto from '@/models/Integrations/IntegrationDto';

// Integration system IDs for SSO providers
const INTEGRATION_SYSTEM_ID_MICROSOFT_365 = 'e98c3b16-5830-6357-d4da-e8dee948cd91';
const INTEGRATION_SYSTEM_ID_GOOGLE_WORKSPACE = 'f09d4c27-6941-7468-e5eb-f9eff059de02';
const INTEGRATION_STATUS_ACTIVE = 90;

@Component({
    name: 'AgencyAuthenticationEdit'
})
export default class extends GiganautVueDialog {

  public entity = new UpdateAgencyAuthenticationRequest();

  private allAuthenticationProviders = [
    { text: 'Email/Password (Firebase)', value: 2 },
    { text: 'Microsoft Entra', value: 3 },
    { text: 'Google Workspace', value: 4 }
  ];

  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      // Load integrations if not already loaded
      if (AgencySettingsModule.integrations.length === 0) {
        await AgencySettingsModule.getIntegrations();
      }
      // Load current values from agency
      this.entity.identityProvider = AgencyModule.currentAgency.identityProvider || 2;
      this.entity.updatedAt = AgencyModule.currentAgency.updatedAt;
    }
  }

  get hasMicrosoft365SSOIntegration(): boolean {
    return AgencySettingsModule.integrations.some((i: IntegrationDto) =>
      i.integrationSystemId === INTEGRATION_SYSTEM_ID_MICROSOFT_365 &&
      i.status === INTEGRATION_STATUS_ACTIVE &&
      this.isSSOEnabledForIntegration(i)
    );
  }

  get hasGoogleWorkspaceSSOIntegration(): boolean {
    return AgencySettingsModule.integrations.some((i: IntegrationDto) =>
      i.integrationSystemId === INTEGRATION_SYSTEM_ID_GOOGLE_WORKSPACE &&
      i.status === INTEGRATION_STATUS_ACTIVE &&
      this.isSSOEnabledForIntegration(i)
    );
  }

  private isSSOEnabledForIntegration(integration: IntegrationDto): boolean {
    if (!integration.settings) return false;
    const setting = integration.settings.find(s => s.key === 'sso_enabled');
    return setting ? setting.value === 'true' : false;
  }

  get availableProviders() {
    return this.allAuthenticationProviders.filter(provider => {
      if (provider.value === 2) return true; // Firebase always available
      if (provider.value === 3) return this.hasMicrosoft365SSOIntegration;
      if (provider.value === 4) return this.hasGoogleWorkspaceSSOIntegration;
      return false;
    });
  }

  get unavailableProviderMessage(): string {
    const unavailable: string[] = [];
    if (!this.hasMicrosoft365SSOIntegration) {
      unavailable.push('Microsoft Entra');
    }
    if (!this.hasGoogleWorkspaceSSOIntegration) {
      unavailable.push('Google Workspace');
    }
    if (unavailable.length === 0) return '';
    if (unavailable.length === 2) {
      return 'To enable SSO with Microsoft Entra or Google Workspace, first configure the integration in Settings > Integrations with SSO enabled.';
    }
    return `To enable SSO with ${unavailable[0]}, first configure the integration in Settings > Integrations with SSO enabled.`;
  }

  get isValid() {
    return true;
  }

  get loading() {
    return AgencyModule.loadingAgency;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    await AgencyModule.updateAuthentication(this.entity);
    this.dialog = false;
  }
}
